import axios from "axios";

export default {
    getNotesByHistoricStore(historicStoreId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/note/" +
                historicStoreId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getNotesByHistoricStoreSecure(historicStoreId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/note/" +
                historicStoreId + "/secure",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createNotesByHistoricStore(historicStoreId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/note/" +
                historicStoreId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveTab(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/historic/tab",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateTemplate(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/historic/tab",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    cloneTemplate(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/historic/tab/clone",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteTemplate(id) {
        return axios({
            method: "delete",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/historic/tab/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getProfessionalPermissions(historicStoreId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/" +
                historicStoreId +
                "/professionalPermissions",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getProfessionalPermission(historicStoreId, professionalPermissionId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/" +
                historicStoreId +
                "/professionalPermission/" +
                professionalPermissionId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createProfessionalPermissions(historicStoreId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/" +
                historicStoreId +
                "/professionalPermissions",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateProfessionalPermissions(historicStoreId, permissionId, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/" +
                historicStoreId +
                "/professionalPermissions/" +
                permissionId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteProfessionalPermissions(historicStoreId, permissionId) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicStore/" +
                historicStoreId +
                "/professionalPermissions/" +
                permissionId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
